import { type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { usePortalProviderId } from '../PortalProvider/PortalProvider'

export interface PortalProps {
  /** 要透過 Portal 渲染的子內容 */
  children?: ReactNode
  /** 是否停用 Portal（直接在原位渲染） */
  disablePortal?: boolean
}

/**
 * Portal 是傳送門元件，將子內容渲染到 PortalProvider 指定的 DOM 節點或 document.body。
 * 可透過 disablePortal 停用傳送，使內容在原位渲染。
 */
export const Portal = (props: PortalProps) => {
  const { children, disablePortal } = props
  const portalProviderId = usePortalProviderId()
  if (disablePortal) return children
  if (portalProviderId === null) return null
  const portalElement = document.querySelector(`#${portalProviderId}`) || document.body
  return createPortal(children, portalElement)
}
